"use strict";

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.ssrWindow = {}));
})(void 0, function (exports) {
  'use strict';
  /* eslint-disable no-param-reassign */

  function isObject(obj) {
    return obj !== null && _typeof(obj) === 'object' && 'constructor' in obj && obj.constructor === Object;
  }

  function extend(target, src) {
    if (target === void 0) {
      target = {};
    }

    if (src === void 0) {
      src = {};
    }

    Object.keys(src).forEach(function (key) {
      if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        extend(target[key], src[key]);
      }
    });
  }

  var ssrDocument = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ''
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS: function createElementNS() {
      return {};
    },
    importNode: function importNode() {
      return null;
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    }
  };

  function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
  }

  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ''
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    },
    history: {
      replaceState: function replaceState() {},
      pushState: function pushState() {},
      go: function go() {},
      back: function back() {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
      return {};
    },
    requestAnimationFrame: function requestAnimationFrame(callback) {
      if (typeof setTimeout === 'undefined') {
        callback();
        return null;
      }

      return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(id) {
      if (typeof setTimeout === 'undefined') {
        return;
      }

      clearTimeout(id);
    }
  };

  function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
  }

  exports.extend = extend;
  exports.getDocument = getDocument;
  exports.getWindow = getWindow;
  exports.ssrDocument = ssrDocument;
  exports.ssrWindow = ssrWindow;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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